import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Label } from 'reactstrap';

import {
  checkNullValue,
  formattedDate,
  noOfDaysValueGetter,
} from '../utils/Util';
import BasicDetails from './BasicDetails';

interface IApproveLeaveDetailsProps {
  user?: any;
  leaveDetails: any;
}

const ApproveLeaveDetails: React.FunctionComponent<
  IApproveLeaveDetailsProps
> = ({ leaveDetails }) => {
  const getProfileDetails = () => (
    <>
      <BasicDetails user={leaveDetails} employeeKeyShow={true} />
      <div className="mt-3 mb-2 pb-2 mx-4">
        <Label className=" mt-3 mb-1 model-comment-title toolBar-name">
          Leave Request Details
        </Label>
        <Row>
          <Col xs={4} md={4}>
            <Label className="mb-0 model-label-name">Leave From Date</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formattedDate(leaveDetails?.startDate)}
            </Label>
          </Col>
          <Col xs={4} md={4}>
            <Label className="mb-0 model-label-name">Leave To Date</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formattedDate(leaveDetails?.endDate)}
            </Label>
          </Col>
          <Col xs={4} md={4}>
            <Label className="mb-0 model-label-name">No of Days</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {noOfDaysValueGetter(leaveDetails) ?? '-'}
            </Label>
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <Col xs={4} md={4}>
            <Label className="mb-0 model-label-name">Leave Type</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(leaveDetails?.leaveTypeName)}
            </Label>
          </Col>
          <Col xs={4} md={4}>
            <Label className="mb-0 model-label-name">Reason for leave</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(leaveDetails?.reasonForLeave)}
            </Label>
          </Col>
        </Row>
      </div>
    </>
  );
  return getProfileDetails();
};

export default ApproveLeaveDetails;
